import {Component} from '@angular/core';
import {FieldType, FormlyModule} from '@ngx-formly/core';
import {ReactiveFormsModule} from '@angular/forms';
import {NzInputNumberModule} from 'ng-zorro-antd/input-number';
import {NzInputModule} from 'ng-zorro-antd/input';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'zorrly-input',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule,
    NzInputNumberModule,
    NzInputModule,
  ],
  template: `
    <input *ngIf="props.type !== 'number'; else numberTmp"
           nz-input
           [formControl]="$any(formControl)"
           [type]="props.type || 'text'"
           [formlyAttributes]="field"/>
    <ng-template #numberTmp>
      <nz-input-number style="width: 100%" [formControl]="$any(formControl)" [formlyAttributes]="field"></nz-input-number>
    </ng-template>
  `,

})
export class ZorrlyInputComponent extends FieldType {
}
